var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters, mapActions } from 'vuex';
import { CATEGORY, CART, ACCOUNT, LOCATION } from '@/stores/defs';
import { generateUniqueId, calculateTotal } from '@/utils/helper.functions';
import { ECOMMERCE_ACTIONS } from '@/common/analytic-events/ecommerceActions';
// @ts-ignore
import Analytics from '@Analytics';
import { CART_ANALYTIC_EVENT } from '@/common/analytic-events/cartAnaltyicEvent';
// vue analytic ecommerce specific functions
var eCommerceAnalyticsMixin = {
    computed: __assign({}, mapGetters({
        transactionId: CART.GET_TRANSACTION_ID,
        customer: ACCOUNT.GET_CUSTOMER,
        location: LOCATION.GET_LOCATION,
        getCategoryForItem: CATEGORY.GET_CATEGORY_FOR_ITEM,
        items: CART.ITEMS
    })),
    methods: __assign({}, mapActions({
        setTransactionId: CART.SET_TRANSACTION_ID,
    }), { createTransaction: function (uniqueId) {
            // this.$ga.ecommerce.addTransaction({
            // 	id: uniqueId,
            // 	affiliation: this.location.name
            // });
        },
        addImpression: function (cartItem) {
            // this.$ga.ecommerce.addImpression({
            // 	id: cartItem.id,
            // 	name: cartItem.name,
            // 	category: this.getCategoryForItem(cartItem.id)
            // });
        },
        addTrackedItem: function (itemObj) {
            var product = __assign({ id: itemObj.item.id, name: itemObj.item.name, category: this.getCategoryForItem(itemObj.item.id) }, (itemObj.list && { list: itemObj.list }));
            // @ts-ignore
            if ([ECOMMERCE_ACTIONS.ADD_TO_CART, ECOMMERCE_ACTIONS.CHECKOUT_OPTION, ECOMMERCE_ACTIONS.CHECKOUT].includes(itemObj.action)) {
                product.quantity = itemObj.item.quantity;
                product.price = (itemObj.item.getSingleItemTotal(itemObj.item.options) / 100).toString();
            }
            // this.$ga.ecommerce.addProduct(product);
        },
        trackItem: function (itemObj) {
            // seperate from final flow of adding to transaction. these are standalone
            this.addTrackedItem(itemObj);
            // this.$ga.ecommerce.setAction(itemObj.action, {...(itemObj.list && { list: itemObj.list })});
            // this.$ga.ecommerce.send();
            if (!this.items) {
                return;
            }
            if (this.items.length === 1) {
                Analytics.$emit('analytics-event', {
                    eventCategory: CART_ANALYTIC_EVENT.category,
                    eventAction: CART_ANALYTIC_EVENT.actions.firstAdd,
                    label: CART_ANALYTIC_EVENT.label.cart
                });
            }
        },
        // this executes on checkout
        trackCheckoutEvent: function (checkoutObj) {
            // create transaction id
            // for each step, you must add all items
            this.addAllTrackedItems({ items: checkoutObj.items, action: ECOMMERCE_ACTIONS.CHECKOUT_OPTION });
            // this.$ga.ecommerce.setAction(ECOMMERCE_ACTIONS.CHECKOUT, {
            // 	'step': checkoutObj.step,
            // 	'option': checkoutObj.option
            // });
            this.sendCheckoutOption();
        },
        addAllTrackedItems: function (itemObj) {
            var _this = this;
            itemObj.items.forEach(function (cartItem) {
                _this.addTrackedItem({ item: cartItem, action: itemObj.action });
            });
        },
        trackTransaction: function (cartItems, apiOrder) {
            var _this = this;
            var uniqueId = (!this.customer.id) ? generateUniqueId() : generateUniqueId(this.customer.id);
            var revenue = (calculateTotal(apiOrder.totals) / 100);
            var discount = "";
            // get name of discounts used
            if (apiOrder.discounts) {
                discount = this.getDiscountNames(apiOrder.discounts);
            }
            var shipping = this.orderHasShipping(apiOrder);
            cartItems.forEach(function (cartItem) {
                _this.addTrackedItem({ item: cartItem, action: ECOMMERCE_ACTIONS.CHECKOUT });
            });
            var transaction = __assign({ id: uniqueId, affiliation: this.location.name, revenue: revenue.toString(), tax: (apiOrder.totals.tax / 100).toString() }, (discount && { coupon: discount }), (shipping && { shipping: shipping.toString() }));
            // this.$ga.ecommerce.setAction(ECOMMERCE_ACTIONS.PURCHASE, transaction);
            // this.$ga.query('send', 'pageview');
        },
        getDiscountNames: function (discounts) {
            return discounts.reduce(function (accum, current) { return current.name + "+"; }, "");
        },
        orderHasShipping: function (apiOrder) {
            if (apiOrder.serviceCharges && apiOrder.serviceCharges.length) {
                var serviceCharge = 0;
                for (var _i = 0, _a = apiOrder.serviceCharges; _i < _a.length; _i++) {
                    var serviceCharge_1 = _a[_i];
                    if (serviceCharge_1.name === "Delivery Charge") {
                        return (serviceCharge_1.amount / 100);
                    }
                }
            }
            else {
                return 0;
            }
        },
        sendCheckoutOption: function () {
            // this.$ga.query('send', 'event', 'Checkout', 'Option', {
            // 	hitCallback: function() {
            // 	},
            // });
        } })
};
export default eCommerceAnalyticsMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/eCommerceAnalyticsMixin.ts
// module id = null
// module chunks = 